module.exports = "/_next/static/images/coinLogoImage-b1ca35181ad2cf7f779fdf142b44fcc0.png";